<template>
	<div class="content">
		<div :class="`${$vuetify.breakpoint.smAndDown? 'content-info-sm' : 'content-info'} py-6 px-4`">
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" md="2" class="pa-1">
				Claim date
				<DatePicker
					:color="color"
					:lableText="''"
					:isOutlined="true"
					:dateInit="date_init"
					@date="date = $event"
				/>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" md="2" class="pa-1">
				Approval by
				<v-select
					v-model="approval"
					:items="app_employees"
					:color="color"
					:error="!approval"
					placeholder="REQUIRED"
					item-text="display_name"
					item-value="id"
					outlined
					return-object
					hide-details
					dense
				/>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" md="2" class="pa-1">
				Claim description
				<v-text-field 
					v-model="description" 
					placeholder="REQUIRED"
					:color="color"
					:error="description.length === 0"
					outlined
					hide-details
					dense
				/>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" md="2" class="pa-1">
				Currency
				<v-select
					v-model="currency"
					:items="currencies"
					:color="color"
					item-text="code"
					item-value="id"
					outlined
					return-object
					hide-details
					dense
				/>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6" md="2" class="pa-1">
				Amount
				<v-text-field
					:value="`${currency && currency.symbol} ${formatAmount(valueSum)}`"
					outlined
					disabled
					dense
					hide-details
					background-color="#FFFFFF"
				>
				</v-text-field>
			</v-col>
		</div>
		<v-alert class="submit-claim-error mx-5" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<div class="my-5 mx-1 px-4">
			Attached Expenses
			<v-btn  outlined color="#00AAFD" class="ml-5" @click="$emit('add-receipts')">
				<v-icon left>mdi-plus</v-icon>
				<span v-if="$vuetify.breakpoint.smAndDown">ADD</span>
				<span v-else>ADD EXPENSE</span>
			</v-btn>
		</div>
		<TableAttachedReceipt 
			class="content-table mt-2 mb-5"
			:header="header_local"
			:items="filterResults"
			:color="color" 
			:currencies="currencies"
			:symbol="currency && currency.symbol"
			:gross="formatAmount(valueSum)"
			:tax="formatAmount(taxSum)"
			:amount="formatAmount(toPaySum)"
			:markup="formatAmount(markupSum)"
			:isValidation="true"
			:isFile="true"
			@row-click="$emit('row-click', $event)"
			@selected="btnStatus = $event"
		/>
		<div :class="$vuetify.breakpoint.smAndDown ? 'add-receipts-btn-xs':'add-receipts-btn'">
			<div :class="`default-btn ${ btnStatus ? 'delete-btn-able':'delete-btn-disable' }`" @click="onDelReceipts()">
				<DeleteIcon width="20" height="20" :color="btnStatus ? 'rgba(8, 14, 20, 0.7)' : 'rgba(8, 14, 20, 0.4)'" class="mr-1 mt-1"/>
				<span v-if="$vuetify.breakpoint.smAndDown">Delete</span>
				<span v-else>Delete Expenses</span>
			</div>
			<div :class="`default-btn mx-3 ${ submit_status && approval && description.length !== 0 && date? 'create-btn-able':'create-btn-disable'}`" @click="onSubmit()">
				<CircleIcon v-if="!submit_loading" width="20" height="20" color="#FFFFFF" class="mr-2"/>
				<v-progress-circular v-if="submit_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>
				Submit
			</div>
			<div :class="`default-btn ${ submit_status && approval && description.length !== 0 && date? 'print-btn-able':'print-btn-disable'}`" @click="onSaveOrLater()">
				<SaveIcon v-if="!redraft_loading" width="20" height="20" :color="submit_status && approval && description.length !== 0 && date? '#2196F3': 'rgba(8, 14, 20, 0.4)'" class="mr-2"/>
				<v-progress-circular v-if="redraft_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
				<span v-if="$vuetify.breakpoint.smAndDown" >Save</span>
				<span v-else>Save and continue later</span>
			</div>
		</div>
	</div>
</template>
<script>
import TableAttachedReceipt from "@/components/table/table_attached_receipt.vue";
import DeleteIcon from "@/components/icons/delete_outline";
import CircleIcon from "@/components/icons/submit_circle_outline";
import SaveIcon from "@/components/icons/save";
import DatePicker from "@/components/date/date_picker.vue";

import config from "@/config.js";
import moment from 'moment';

export default {
	name: 'ClaimContent',
	props: {
		color: {
			type: String,
			default: ""
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		items: {
			type: Array,
			default: () => []
		},
		update_receipts: {
			type: Array,
			default: () => []
		},
	},
	components: {
		TableAttachedReceipt,
		DeleteIcon,
		CircleIcon,
		SaveIcon,
		DatePicker
	},
	data() {
		return {
			error_msg: '',
			date_init: new Date().toISOString().substr(0, 10),
			date: new Date().toISOString().substr(0, 10),
			app_employees: [],
			approval: null,
			description: '',
			currency: this.getDefaultCurrency(),
			converted_values: [],

			header_local: config.receipts_head.filter(head => {return head.showable && head.value !=='is_used'}),
			changed_receipts: this.update_receipts,
			btnStatus: false,
			submit_loading: false,
			redraft_loading: false
		}
	},
	created() {
		this.load_app_employees();
		this.onReCalculate();
	},
	watch: {
		currencies() {
			if (this.currencies.length !== 0) {
				this.currency = this.currencies[0];
			}
		},
		currency() {
			this.onReCalculate();
		},
		date() {
			if (this.date) {
				this.onReCalculate();
			}
		},
		items: {
			handler: function() { 
				this.onReCalculate();
			},
			
			deep: true
		},
		update_receipts() {
			this.changed_receipts = this.update_receipts;
		}
	},
	computed: {
		valueSum() {
			const value = this.converted_values.reduce((sum, item) => {
				return this._add(sum, item.amount);
			}, 0);

			return Number(value.toFixed(2));
		},
		taxSum() {
			const tax = this.converted_values.reduce((sum, item) => {
				return this._add(sum, item.gst);
			}, 0);

			return Number(tax.toFixed(2));
		},
		toPaySum() {
			const toPay = this.converted_values.reduce((sum, item) => {
				return this._add(sum, item.to_pay);
			}, 0);

			return Number(toPay.toFixed(2));
		},
		markupSum() {
			const markup = this.converted_values.reduce((sum, item) => {
				return this._add(sum, item.value);
			}, 0);

			return Number(markup.toFixed(2));
		},
		user_abid() {
			let user_abid = 0;

			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			}

			return user_abid;
		},
		filterResults() {
			const filterRes = [];
					
			this.items.forEach(res => {
				const obj = {};		

				for (const [key, value] of Object.entries(res)) {
					if (key === 'job') {
						obj['code'] = value;
						obj['title'] = value;
					} else if (key === 'thumbnail') {
						obj['image'] = value;
					} else if(key === 'value') {
						obj['value'] = Number(value);
					} else if(key === 'tax_amount') {
						obj['tax_amount'] = Number(value);
					} else if(key === 'markup_perc') {
						obj['markup_perc'] = Number(value);
					} else if(key === 'markup_value') {
						obj['markup_value'] = Number(value);
					} else if (key === 'desc') {
						obj['description'] = value;
					} else {
						obj[`${key}`] = value;
					}
				}

				obj['id']	= res.id;
				obj['select'] = false;

				const amount = Number(res.value);
				const amount_tax = Number(res.tax_amount);
				obj['amount'] = amount + amount_tax;

				filterRes.push(obj);
			});

			return filterRes;
		},
		submit_status() {
			let submit_status = true;
			if (this.filterResults.length !== 0) {
				this.filterResults.forEach(res => {
					if (res.value === '0.00') {
						submit_status = false;
					}
					if (!res.kind) {
						submit_status = false;
					}
					if (!res.code) {
						submit_status = false;
					}
					if (!res.title) {
						submit_status = false;
					}
					if (!res.phase) {
						submit_status = false;
					}
				})
			} else {
				submit_status = false;
			}
			return submit_status;
		},
	},
	methods: {
		load_app_employees() {
			const url = "/api/addressbook?abook_types=3&has_privilege=Secap"
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.app_employees = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e;
				})
		},
		formatAmount(value) {
			// from nmber to string, 12345.00 -> 12,345.00
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(Number(value) || 0);
		},
		parseAmount(value) {
			// from string to nmber, 12,345.00 -> 12345.00 
			const amount = Number(String(value).replace(/,/g, ''));

			return Number.isNaN(amount) ? 0 : amount;
		},
		getDefaultCurrency() {
			const currency_temp_arr = this.currencies.filter(c => { return c.code === "AUD" });
			return currency_temp_arr[0];
		},
		onDelReceipts() {
			if(!this.btnStatus) return;
			const arr_tmp = this.filterResults.filter(res => {return res.select});
			const del_ids = arr_tmp.map(arr => { return arr.id});

			this.btnStatus = false;

			this.$emit('delete', del_ids);
		},
		async onSaveOrLater() {
			if (this.redraft_loading) return;

			if(!(this.submit_status && this.approval && this.description.length !== 0)) return;

			if (this.changed_receipts.length !== 0) {
				this.redraft_loading = true;

				for (let index = 0; index < this.filterResults.length; index++) {
					const item = this.filterResults[index];
					if (this.changed_receipts.includes(item.id)) {
						const receipt_obj = {
							employee_id: item.employee ? item.employee.id : item.employee_id,
							desc: item.description || item.desc || '',
							date: moment(item.date).format("YYYY-MM-DD"),
							currency_id: item.currency.id,
							gross: typeof(item.value) === 'string' ? this.parseAmount(item.value) : Number(item.value.toFixed(2)),
							has_tax: item.has_tax ? 1 : 0,
							job_id: item.code.id,
							phase_id: item.phase.id,
							kind_id: item.kind.id,
							tax_mode: item.tax_mode,
							tax_perc: typeof(item.tax_perc) === 'string' ? this.parseAmount(item.tax_perc) : Number(item.tax_perc.toFixed(2)),  
							tax_amount: typeof(item.tax_amount) === 'string' ? this.parseAmount(item.tax_amount) : Number(item.tax_amount.toFixed(2)), 
							markup_perc: typeof(item.markup_perc) === 'string' ? this.parseAmount(item.markup_perc) : Number(item.markup_perc.toFixed(2)), 
							value: typeof(item.markup_value) === 'string' ? this.parseAmount(item.markup_value) : Number(item.markup_value.toFixed(2)), 
						};

						await this._updateReceipt(item.id, receipt_obj);
					}
				}
				this.redraft_loading = false;
			}

			if (this.changed_receipts.length === 0) {
				this.redraft_loading = true;

				const params = {
					supplier_id: this.user_abid,
					date: this.date,
					desc: this.description,
					currency_id: this.currency.id,
					approval_by: this.approval.id,
					status: config.claim_statuses.draft.value,
				};

				const details = [];
				for (let index = 0; index < this.filterResults.length; index++) {
					const element = this.filterResults[index];

					let value = element.value;
					let tax_amount = element.tax_amount;
					let amount = element.amount;
					let markup_value = element.markup_value;
					if (element.currency.id !== this.currency.id) {
						const rate = Number(await this._get_exchange_rate(this.currency.id, this.date));
						const origin_rate = Number(await this._get_exchange_rate(element.currency.id, element.date));

						value = Number((rate * (value / origin_rate)).toFixed(2));
						tax_amount = tax_amount === 0 ? 0 : Number((rate * (tax_amount / origin_rate)).toFixed(2));
						amount = amount === 0 ? 0 : Number((rate * (amount / origin_rate)).toFixed(2));
						markup_value = markup_value === 0 ? 0 : Number((rate * (markup_value / origin_rate)).toFixed(2));
					}

					details.push({
						receipt_id: element.id,
						amount: amount,
						description: element.description,
						phase_id: element.phase.id,
						job_id: element.code.id,
						kind_id: element.kind.id,
						gross: value,
						tax_mode: element.tax_mode,
						tax_perc: typeof(element.tax_perc) === 'string' ? this.parseAmount(element.tax_perc) : Number(element.tax_perc),
						tax_amount: tax_amount,
						markup: typeof(element.markup_perc) === 'string' ? this.parseAmount(element.markup_perc) : Number(element.markup_perc),
						value_fc: markup_value,
					});
				}

				params['details'] = details;

				this._createClaim(params);
			}
		},
		async onSubmit() {
			if (this.submit_loading) return;

			if(!(this.submit_status && this.approval && this.description.length !== 0)) return;

			if (this.changed_receipts.length !== 0) {
				this.submit_loading = true;

				for (let index = 0; index < this.filterResults.length; index++) {
					const item = this.filterResults[index];
					if (this.changed_receipts.includes(item.id)) {
						const receipt_obj = {
							employee_id: item.employee ? item.employee.id : item.employee_id,
							desc: item.description || item.desc || '',
							date: moment(item.date).format("YYYY-MM-DD"),
							currency_id: item.currency.id,
							gross: typeof(item.value) === 'string' ? this.parseAmount(item.value) : Number(item.value.toFixed(2)),
							has_tax: item.has_tax ? 1 : 0,
							job_id: item.code.id,
							phase_id: item.phase.id,
							kind_id: item.kind.id,
							tax_mode: item.tax_mode,
							tax_perc: typeof(item.tax_perc) === 'string' ? this.parseAmount(item.tax_perc) : Number(item.tax_perc.toFixed(2)),  
							tax_amount: typeof(item.tax_amount) === 'string' ? this.parseAmount(item.tax_amount) : Number(item.tax_amount.toFixed(2)), 
							markup_perc: typeof(item.markup_perc) === 'string' ? this.parseAmount(item.markup_perc) : Number(item.markup_perc.toFixed(2)), 
							value: typeof(item.markup_value) === 'string' ? this.parseAmount(item.markup_value) : Number(item.markup_value.toFixed(2)), 
						};

						await this._updateReceipt(item.id, receipt_obj);
					}
				}

				this.submit_loading = false;
			}

			if (this.changed_receipts.length === 0) {
				this.submit_loading = true;

				const params = {
					supplier_id: this.user_abid,
					date: this.date,
					desc: this.description,
					currency_id: this.currency.id,
					approval_by: this.approval.id,
					status: config.claim_statuses.draft.value
				};

				const details = [];
				for (let index = 0; index < this.filterResults.length; index++) {
					const element = this.filterResults[index];

					let value = element.value;
					let tax_amount = element.tax_amount;
					let amount = element.amount;
					let markup_value = element.markup_value;
					if (element.currency.id !== this.currency.id) {
						const rate = Number(await this._get_exchange_rate(this.currency.id, this.date));
						const origin_rate = Number(await this._get_exchange_rate(element.currency.id, element.date));

						value = Number((rate * (value / origin_rate)).toFixed(2));
						tax_amount = tax_amount === 0 ? 0 : Number((rate * (tax_amount / origin_rate)).toFixed(2));
						amount = amount === 0 ? 0 : Number((rate * (amount / origin_rate)).toFixed(2));
						markup_value = markup_value === 0 ? 0 : Number((rate * (markup_value / origin_rate)).toFixed(2));
					}

					details.push({
						receipt_id: element.id,
						amount: amount,
						description: element.description,
						phase_id: element.phase.id,
						job_id: element.code.id,
						kind_id: element.kind.id,
						gross: value,
						tax_mode: element.tax_mode,
						tax_perc: typeof(element.tax_perc) === 'string' ? this.parseAmount(element.tax_perc) : Number(element.tax_perc),
						tax_amount: tax_amount,
						markup: typeof(element.markup_perc) === 'string' ? this.parseAmount(element.markup_perc) : Number(element.markup_perc),
						value_fc: markup_value,
					});
				}

				params['details'] = details;

				this._createClaim(params, false);
			}
		},
		async onReCalculate() {
			const values = this.filterResults.map(res => {
				return {
					date: res.date,
					currency_id: res.currency.id,
					currency_exrate: res.currency.exrate,
					amount: Number(res.value) || 0,
					gst: Number(res.tax_amount) || 0,
					to_pay: Number(res.amount) || 0,
					value: Number(res.markup_value) || 0
				};
			});

			if (values.length === 0) {
				this.converted_values = [];
				return;
			}

			const requires_exchange = this.currency
				&& values.some(item => item.currency_id !== this.currency.id);
			const rate = requires_exchange
				? Number(await this._get_exchange_rate(this.currency.id, this.date))
				: 1;

			for (let index = 0; index < values.length; index++) {
				await this.exchange_rate(values[index], rate);
			}

			this.converted_values = values;
		},
		async exchange_rate(origin, rate) {
			const exchanged = origin;

			if (this.currency && origin.currency_id !== this.currency.id) {
				let origin_rate = null;
				if (!origin.currency_exrate) {
					origin_rate = await this._get_exchange_rate(origin.currency_id, origin.date);
				} else {
					origin_rate = origin.currency_exrate;
				}

				const multiplier = Number(rate) / Number(origin_rate);
				['amount', 'gst', 'to_pay', 'value'].forEach(key => {
					exchanged[key] = Number((Number(origin[key]) * multiplier).toFixed(2));
				});
			} 

			return exchanged;
		},
		async _get_exchange_rate(currency_id, date) {
			let rate = null;
			const url = "/api/config/currency/" + currency_id + "/exchange_rates/" + date;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						rate = data.rate;
					} else {
						this.error_msg = reason;
					}					
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
			
			return rate;
		},
		_add(num1, num2) {
			const num1Digits = (num1.toString().split('.')[1] || '').length;
			const num2Digits = (num2.toString().split('.')[1] || '').length;
			const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
			return (num1 * baseNum + num2 * baseNum) / baseNum;
		},
		async _updateReceipt(id, update_receipt_obj) {
			const url = "/api/expenses/receipts/" + id;

			await axios
				.put(url, update_receipt_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.changed_receipts = this.changed_receipts.filter(changed_receipt => {return changed_receipt !== data.id});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.redraft_loading = false;
					this.submit_loading = false;
				});	
		},
		_createClaim(claim_params, is_draft=true) {
			const url = "/api/expenses/claims";

			axios
				.post(url, claim_params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (is_draft) {
							this.$emit('back');
							this.redraft_loading = false;
						} else {
							const params = {
								supplier_id: data.supplier.id,
								date: data.date,
								period_id: data.period.id,
								desc: data.description,
								currency_id: data.currency.id,
								approval_by: data.approval_by.id,
								status: config.claim_statuses.pending.value,
								remark: '',
								send_email: true
							};

							const details = [];
							for (let index = 0; index < data.details.length; index++) {
								const detail = data.details[index];

								details.push({
									receipt_id: detail.receipt.id,
									amount: Number(detail.amount),
									description: detail.description,
									phase_id: detail.phase.id,
									job_id: detail.job.id,
									kind_id: detail.kind.id,
									gross: Number(detail.gross),
									tax_mode: detail.tax_mode,
									tax_perc: Number(detail.tax_perc),
									tax_amount: Number(detail.tax_amount),
									markup: Number(detail.markup),
									value_fc: Number(detail.value_fc),
								});
							}

							params['details'] = details;
							this._updateClaim(data.id, params);
						}
					} else {
						this.error_msg = reason;
						this.redraft_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.redraft_loading = false;
				});
		},
		_updateClaim(claim_id, claim_params) {
			const url = `/api/expenses/claims/${claim_id}`;

			axios
				.put(url, claim_params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.$emit('back');
						this.submit_loading = false;
					} else {
						this.error_msg = reason;
						this.submit_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.submit_loading = false;
				});
		}
	}
}
</script>
<style lang="scss" scoped>
.content {
  background: #FAFAFA;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
	width: 100%;
}
.content-info {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}
.content-info-sm {
  display: flex;
  flex-flow: column nowrap;
	align-items: flex-start;
  width: 100%;
}
.add-receipts-btn {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	padding: 0 16px;
	height: 70px;
	background: #FAFAFA;
	div {
		height: 36px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 36px;
	}
}
.add-receipts-btn-xs {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	padding: 0 4px;
	height: 70px;
	background: #FAFAFA;
	div {
		height: 36px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 36px;
	}
}
.default-btn {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
	padding: 0 14px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	border-radius: 4px; 
}
.delete-btn-able {
  color: rgba(8, 14, 20, 0.7);
	border: 1px solid rgba(25, 42, 62, 0.7);
  &:hover {
		cursor: pointer;
	}
}
.delete-btn-disable {
  color: rgba(8, 14, 20, 0.4);
	border: 1px solid rgba(25, 42, 62, 0.4);
}
.create-btn-able {
  color: #FFFFFF;
	background: #00AAFD;
  &:hover {
		cursor: pointer;
	}
}
.create-btn-disable {
  color: #FFFFFF;
	background: rgba(8, 14, 20, 0.4);
}
.print-btn-able {
  color: #2196F3;
  border: 1px solid #2196F3;
  &:hover {
		cursor: pointer;
	}
}
.print-btn-disable {
  color: rgba(8, 14, 20, 0.4);
  border: 1px solid rgba(8, 14, 20, 0.4);
}
::v-deep {
	.v-input input::placeholder {
		color: red;
	}
}
</style>
